<ng-container *ngIf="isSidebarOpen">
  <div
    class="overlay"
    tabindex="0"
    role="button"
    (click)="close()"
    (keydown)="($event.key === 'Enter' || $event.key === ' ') && close()"
    [attr.aria-label]="'global.close' | translate"></div>

  <aside class="sidebar">
    <!-- Drawer header, shown when the sidebar opens over the page -->
    <header class="sidebar__header">
      <button
        class="sidebar__close-button"
        type="button"
        (click)="close()"
        [attr.aria-label]="'global.close' | translate">
        <i class="agres-close" aria-hidden="true"></i>
      </button>
    </header>

    <!-- Navigation -->
    <nav class="sidebar__nav" [attr.aria-label]="'global.menu' | translate">
      <!-- General -->
      <div class="sidebar__group">
        <p class="sidebar__group-title">{{ 'sidebar.group-general' | translate }}</p>
        <ul class="sidebar__menu">
          <!-- Dashboard -->
          <li class="sidebar__menu-item" [class.active]="activeRoute('/')">
            <a class="sidebar__link" [routerLink]="'/'">
              <i class="sidebar__icon agres-app" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-dashboard' | translate }}</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Operation -->
      <div class="sidebar__group">
        <p class="sidebar__group-title">{{ 'sidebar.group-operation' | translate }}</p>
        <ul class="sidebar__menu">
          <!-- Navigation Report -->
          <li
            class="sidebar__menu-item"
            [class.active]="activeRoute('/gestao-operacao/gestao-arquivo')"
            [class.sidebar__menu-item--locked]="
              auth.forbids(auth.permissions.NAVIGATE, auth.resources.NAVIGATION_RESULT)
            ">
            <a class="sidebar__link" [routerLink]="'/gestao-operacao/gestao-arquivo'">
              <i class="sidebar__icon agres-navigation-report" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-navigation-report' | translate }}</span>
              <span
                *ngIf="auth.forbids(auth.permissions.NAVIGATE, auth.resources.NAVIGATION_RESULT)"
                class="sidebar__badge sidebar__badge--premium">
                {{ 'sidebar.title-user-premium' | translate }}
              </span>
            </a>
          </li>

          <!-- Fleet Monitoring -->
          <li
            class="sidebar__menu-item"
            [class.active]="activeRoute('/gestao-operacao/monitoramento-frota')"
            [class.sidebar__menu-item--locked]="
              auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)
            ">
            <a
              class="sidebar__link"
              [routerLink]="isRoleFreetier() ? null : '/gestao-operacao/monitoramento-frota'"
              (click)="handlePremiumLinkClick($event, '/gestao-operacao/monitoramento-frota')">
              <i class="sidebar__icon agres-fleet-monitoring" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-monitoring-fleet' | translate }}</span>
              <span
                *ngIf="auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)"
                class="sidebar__badge sidebar__badge--premium">
                {{ 'sidebar.title-user-premium' | translate }}
              </span>
            </a>
          </li>

          <!-- Jobs -->
          <li class="sidebar__menu-item" [class.active]="activeRoute('/administrativo/meus-equipamentos')">
            <a
              class="sidebar__link"
              [routerLink]="isRoleFreetier() ? null : '/administrativo/meus-equipamentos'"
              (click)="handlePremiumLinkClick($event, '/administrativo/meus-equipamentos')">
              <i class="sidebar__icon agres-my-jobs" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-jobs' | translate }}</span>
              <span
                *ngIf="auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)"
                class="sidebar__badge sidebar__badge--premium">
                {{ 'sidebar.title-user-premium' | translate }}
              </span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Field -->
      <div class="sidebar__group">
        <p class="sidebar__group-title">{{ 'sidebar.group-field' | translate }}</p>
        <ul class="sidebar__menu">
          <!-- Fields -->
          <li
            class="sidebar__menu-item"
            [class.active]="activeRoute('/my-fields')"
            [class.sidebar__menu-item--locked]="
              auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)
            ">
            <a
              class="sidebar__link"
              [routerLink]="isRoleFreetier() ? null : '/my-fields/'"
              (click)="handlePremiumLinkClick($event, '/my-fields/')">
              <i class="sidebar__icon agres-field" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-fields' | translate }}</span>
              <span
                *ngIf="auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)"
                class="sidebar__badge sidebar__badge--premium">
                {{ 'sidebar.title-user-premium' | translate }}
              </span>
            </a>
          </li>

          @if (notebookVisible) {
            <li
              class="sidebar__menu-item"
              [class.active]="activeRoute('/field-notebook')"
              [class.sidebar__menu-item--locked]="
                auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)
              ">
              <a
                class="sidebar__link"
                [routerLink]="notebookRoute"
                (click)="handlePremiumLinkClick($event, '/field-notebook')">
                <i class="sidebar__icon agres-file" aria-hidden="true"></i>
                <span class="sidebar__text">{{ 'field-notebook.title' | translate }}</span>
                @if (auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)) {
                  <span class="sidebar__badge sidebar__badge--premium">{{
                    'sidebar.title-user-premium' | translate
                  }}</span>
                }
              </a>
            </li>
          }

          <!-- Recommendation Maps (Hidden) -->
          <li
            *ngIf="!isRoleFreetier()"
            class="sidebar__menu-item"
            [class.active]="activeRoute('/gestao-talhoes') || activeRoute('/mapa-recomendacao')"
            hidden>
            <a class="sidebar__link" [routerLink]="['/gestao-talhoes/mapas-recomendacao']">
              <i class="sidebar__icon agres-device-mobile-vibration" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-recommendation-maps' | translate }}</span>
            </a>
          </li>

          <!-- Weather -->
          <li class="sidebar__menu-item" [class.active]="activeRoute('/gestao-operacao/previsao-tempo')">
            <a class="sidebar__link" [routerLink]="['/gestao-operacao/previsao-tempo']">
              <i class="sidebar__icon agres-sun" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-weather' | translate }}</span>
            </a>
          </li>

          <!-- Utilities -->
          <li class="sidebar__menu-item" [class.active]="activeRoute('/utilities')">
            <a class="sidebar__link" [routerLink]="'/utilities'">
              <i class="sidebar__icon agres-tool" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-utilities' | translate }}</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Data -->
      <div class="sidebar__group">
        <p class="sidebar__group-title">{{ 'sidebar.group-data' | translate }}</p>
        <ul class="sidebar__menu">
          <!-- Agrodrive -->
          <li
            class="sidebar__menu-item"
            [class.active]="activeRoute('/agrodrive')"
            [class.sidebar__menu-item--locked]="
              auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)
            ">
            <a
              class="sidebar__link"
              [routerLink]="isRoleFreetier() ? null : '/agrodrive'"
              (click)="handlePremiumLinkClick($event, '/agrodrive')">
              <i class="sidebar__icon agres-upload-cloud" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-agrodrive' | translate }}</span>
              <span class="sidebar__badge sidebar__badge--coming-soon">EM BREVE</span>
              <span
                *ngIf="auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)"
                class="sidebar__badge sidebar__badge--premium">
                {{ 'sidebar.title-user-premium' | translate }}
              </span>
            </a>
          </li>

          <!-- Data Transfer -->
          <li
            class="sidebar__menu-item"
            [class.active]="activeRoute('/manage/connections')"
            [class.sidebar__menu-item--locked]="
              auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)
            ">
            <a
              class="sidebar__link"
              [routerLink]="isRoleFreetier() ? null : '/manage/connections'"
              (click)="handlePremiumLinkClick($event, '/manage/connections')">
              <i class="sidebar__icon agres-transfer" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'dashboard.title-data-transfer' | translate }}</span>
              <span
                *ngIf="auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)"
                class="sidebar__badge sidebar__badge--premium">
                {{ 'sidebar.title-user-premium' | translate }}
              </span>
            </a>
          </li>
        </ul>
      </div>

      <!-- Help -->
      <div class="sidebar__group">
        <p class="sidebar__group-title">{{ 'sidebar.group-help' | translate }}</p>
        <ul class="sidebar__menu">
          <!-- Support -->
          <li
            class="sidebar__menu-item"
            [class.active]="isSupportActive()"
            [class.sidebar__menu-item--locked]="
              auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)
            ">
            <a
              class="sidebar__link"
              [routerLink]="isRoleFreetier() ? null : '/suporte-tecnico'"
              (click)="handlePremiumLinkClick($event, '/suporte-tecnico')">
              <i class="sidebar__icon agres-file" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-support' | translate }}</span>
              <span
                *ngIf="auth.forbids(auth.permissions.NAVIGATE, auth.resources.FIELD_ADMINISTRATION)"
                class="sidebar__badge sidebar__badge--premium">
                {{ 'sidebar.title-user-premium' | translate }}
              </span>
            </a>
          </li>

          <!-- Remote support (members of a remote support group only) -->
          @if (remoteSupportVisible) {
            <li class="sidebar__menu-item" [class.active]="activeRoute(remoteSupportRoute)">
              <a class="sidebar__link" [routerLink]="remoteSupportRoute">
                <i class="sidebar__icon agres-support" aria-hidden="true"></i>
                <span class="sidebar__text">{{ 'sidebar.title-remote-support' | translate }}</span>
              </a>
            </li>
          }

          <!-- Tecomec Academy (external) -->
          <li class="sidebar__menu-item">
            <a class="sidebar__link" [href]="academyLink" target="_blank" rel="noopener noreferrer">
              <i class="sidebar__icon agres-play-circle" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-academy' | translate }}</span>
              <span class="visually-hidden">{{ 'sidebar.opens-new-tab' | translate }}</span>
              <svg
                class="sidebar__external"
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M7 17 17 7"></path>
                <path d="M8 7h9v9"></path>
              </svg>
            </a>
          </li>

          <!-- About (external) -->
          <li class="sidebar__menu-item">
            <a class="sidebar__link" [href]="aboutLink" target="_blank" rel="noopener noreferrer">
              <i class="sidebar__icon agres-tecomec" aria-hidden="true"></i>
              <span class="sidebar__text">{{ 'sidebar.title-about' | translate }}</span>
              <span class="visually-hidden">{{ 'sidebar.opens-new-tab' | translate }}</span>
              <svg
                class="sidebar__external"
                aria-hidden="true"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M7 17 17 7"></path>
                <path d="M8 7h9v9"></path>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Footer -->
    <footer
      class="sidebar__footer"
      [ngClass]="{
        'sidebar__footer--prod': environmentName === 'PROD',
        'sidebar__footer--dev': environmentName === 'DEV',
        'sidebar__footer--stage': environmentName === 'STAGE',
      }">
      <p class="sidebar__footer-text">
        <ng-container *ngIf="environmentName !== 'STAGE'">&copy;</ng-container>
        isoFarm - {{ 'global.copyright' | translate }}
      </p>
      <button class="sidebar__footer-button" type="button" aria-label="view version details">
        <span class="sidebar__footer-version">{{ versaoGit }} - {{ environmentName }}</span>
      </button>
    </footer>
  </aside>
</ng-container>
